/** Pure security predicates shared by the route and policy editor. */

export function canManageAutomatedOnboarding(permissions: readonly string[]) {
  return permissions.some(
    (permission) =>
      permission === "applications.manage" ||
      permission === "applications.manage!",
  );
}

export function canSaveRegistrationPolicy(input: {
  currentOpenRegistration: boolean;
  nextOpenRegistration: boolean;
  applicationDomainCount: number;
  clientAuthenticationSelected: boolean;
}) {
  // Closing an exposed registration path is a monotonic security reduction
  // and must never depend on repairing unrelated legacy configuration first.
  if (input.currentOpenRegistration && !input.nextOpenRegistration) return true;
  return input.applicationDomainCount > 0 && input.clientAuthenticationSelected;
}
